import createReactComponent from '../createReactComponent';
export default createReactComponent('music-code', 'IconMusicCode', [
  ['path', { d: 'M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M9 17v-13h10v9', key: 'svg-1' }],
  ['path', { d: 'M9 8h10', key: 'svg-2' }],
  ['path', { d: 'M20 21l2 -2l-2 -2', key: 'svg-3' }],
  ['path', { d: 'M17 17l-2 2l2 2', key: 'svg-4' }],
]);
